export default __webpack_public_path__ + "static/media/tac4.0a9d6c4e.jpeg";